import React, { useState } from 'react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="site-header">
      <nav className="wrapper nav-shell" aria-label="Navegacion principal">
        <a className="brand" href="#inicio" aria-label="Inicio que Uauu!">
          <span className="brand-que">que</span>
          <span className="brand-uauu">Uauu!</span>
        </a>

        <div className="desktop-menu">
          <a href="#que-hacemos">Que hacemos</a>
          <a href="#casos">Casos Uauu</a>
          <a href="#contacto">Hablemos</a>
        </div>

          <button
            className="mobile-toggle"
            onClick={toggleMenu}
            aria-label="Toggle menu"
            aria-expanded={isMenuOpen}
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              {isMenuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>

        <div className={`mobile-menu ${isMenuOpen ? 'is-open' : ''}`}>
          <a href="#que-hacemos" onClick={() => setIsMenuOpen(false)}>Que hacemos</a>
          <a href="#casos" onClick={() => setIsMenuOpen(false)}>Casos Uauu</a>
          <a href="#contacto" onClick={() => setIsMenuOpen(false)}>Hablemos</a>
        </div>
      </nav>
    </header>
  );
};

export default Header; 